<template>
  <div class="flex items-center justify-center w-[1000px] h-[600px] rounded-xl">
    <div class="relative flex items-center justify-center w-full h-full bg-white rounded-xl">
      <div
        class="absolute bottom-0 right-0 w-0 h-0 rounded-b-xl border-l-[75px] border-l-transparent border-t-[100px] border-t-transparent border-r-[100px] border-r-[#07455D]">
        <Lock class="-mt-12 ml-12 w-7 h-7 z-50 hover:cursor-pointer text-white" />
      </div>
      <!-- <span class="absolute inset-0 top-24 w-full h-full flex items-center justify-center rounded-full border border-dashed border-common-grey z-40">Integrate Your Favorite Collaborations Tool </span> -->
      <div class="flex flex-col items-center justify-center h-full px-24 py-6">
        <div class="relative flex flex-col items-center justify-center w-full h-1/4 min-h-[150px]">
          <span class="absolute w-[500px] h-[500px] -bottom-[370px] rounded-full border-[2px] border-dashed border-[#B171F9]" />
          <span class="absolute w-80 h-80 -bottom-[290px] rounded-full bg-[#07455D] border-2 border-dashed border-white" />
          <span class="text-[22px] font-medium">{{ $t("Best of Your Portfolio") }}</span>
          <span class="text-[22px] font-medium">{{ $t("with") }} <span class="font-bold">{{ $t("Customer Leads") }} </span></span>
        </div>
        <div class="h-3/4 z-30">
          <img class="flex-shrink-0 h-full rounded-3xl shadow-md-custom" src="@/assets/find-leads-image.png">
        </div>
      </div>
      <div class="absolute flex w-1/2 h-1/2 bottom-0 left-0 bg-gradient-to-tr from-[#2DA7D7]/20 to-transparent opacity-50" />
    </div>
  </div>
</template>

<script>
import { Lock } from "lucide-vue-next"

export default {
  components: {
    Lock
  },
  props: {},
  data() {
    return {}
  },

  methods: {}
}
</script>
<style scoped>
input[type="file"] {
  display: none;
}

.shadow-md-custom {
  --tw-shadow: 0 8px 16px rgba(45, 167, 215, 0.15);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
</style>
